import React from "react";
import { currencyFormatter, numberFormatter } from "../utils/formatters";

const EMICalculator = ({ 
  isOpen, 
  onClose, 
  loanAmount, 
  setLoanAmount, 
  interestRate, 
  setInterestRate, 
  tenureYears, 
  setTenureYears,
  emiValue,
  totalInterest
}) => {
  if (!isOpen) return null;

  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-[0_10px_30px_rgba(0,0,0,0.08)] p-4 mb-3 space-y-4 max-h-[50vh] overflow-y-auto">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-semibold text-gray-900">EMI Calculator</p>
        </div>
        <button
          onClick={onClose}
          className="w-8 h-8 rounded-full flex items-center justify-center text-gray-500 hover:bg-gray-100 transition"
          aria-label="Close EMI calculator"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M6 6L18 18M6 18L18 6"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <div className="flex items-center justify-between text-xs font-semibold text-gray-600">
            <span>Loan amount</span>
            <span className="text-gray-900">₹{numberFormatter.format(loanAmount)}</span>
          </div>
          <div className="bg-gray-50 rounded-2xl border border-gray-200 px-4 py-2 text-right text-lg font-semibold text-gray-900 tracking-wide">
            ₹{numberFormatter.format(loanAmount)}
          </div>
          <input
            type="range"
            min="100000"
            max="10000000"
            step="10000"
            value={loanAmount}
            onChange={(e) => setLoanAmount(Number(e.target.value))}
            className="w-full"
            style={{ accentColor: "#0074bc" }}
            aria-label="Loan amount slider"
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between text-xs font-semibold text-gray-600">
            <span>Interest rate</span>
            <span className="text-gray-900">{interestRate.toFixed(1)}%</span>
          </div>
          <div className="bg-gray-50 rounded-2xl border border-gray-200 px-4 py-2 text-right text-lg font-semibold text-gray-900 tracking-wide flex items-center justify-end gap-1">
            <span>{interestRate.toFixed(1)}</span>
            <span className="text-sm font-medium text-gray-500">%</span>
          </div>
          <input
            type="range"
            min="6"
            max="20"
            step="0.1"
            value={interestRate}
            onChange={(e) => setInterestRate(Number(e.target.value))}
            className="w-full"
            style={{ accentColor: "#0074bc" }}
            aria-label="Interest rate slider"
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between text-xs font-semibold text-gray-600">
            <span>Tenure (Years)</span>
            <span className="text-gray-900">{tenureYears}</span>
          </div>
          <div className="bg-gray-50 rounded-2xl border border-gray-200 px-4 py-2 text-right text-lg font-semibold text-gray-900 tracking-wide">
            {tenureYears} yrs
          </div>
          <input
            type="range"
            min="1"
            max="30"
            step="1"
            value={tenureYears}
            onChange={(e) => setTenureYears(Number(e.target.value))}
            className="w-full"
            style={{ accentColor: "#0074bc" }}
            aria-label="Tenure slider"
          />
        </div>

        <div className="rounded-2xl border border-gray-200 bg-[#F6F8FB] p-2 text-center space-y-2">
          <p className="text-xs uppercase tracking-wide text-gray-500">Monthly installment (EMI)</p>
          <p className="text-3xl font-semibold text-gray-900">{currencyFormatter.format(Math.round(emiValue || 0))}</p>
          <p className="text-[11px] text-gray-500">Total interest approx. {currencyFormatter.format(Math.round(totalInterest || 0))}</p>
        </div>
      </div>
    </div>
  );
};

export default EMICalculator;

